export default __webpack_public_path__ + "static/media/email.48bf5dfe.png";